<template>
    <footer class="pc-body" :class="[{'has-handle': hasHandle}]">
        <div class="footer-container">
            <div class="footer footer-mod-1">
                <div class="logo-wrap">
                    <img class="pc-logo show-pc"
                        :src="config.footerLogo"
                        usemap="#footer-logo"
                        alt="Reolink cloud"/>
                    <map name="footer-logo">
                        <area shape="rect"
                            coords="0,0,104,27"
                            alt="reolink"
                            :href="`${getOfficialUrl( )}`"
                            target="_blank">
                        <area shape="rect"
                            coords="124,0,160,27"
                            alt="reolink"
                            href="/">
                    </map>
                    <img class="m-logo show-m"
                        :src="config.footerLogo"
                        usemap="#footer-logo-m"
                        alt="Reolink cloud"/>
                    <map name="footer-logo-m">
                        <area shape="rect"
                            coords="0,0,104,27"
                            alt="reolink"
                            :href="getOfficialUrl( )"
                            target="_blank">
                        <area shape="rect"
                            coords="124,0,160,27"
                            alt="reolink"
                            href="/">
                    </map>
                </div>
                <reo-link
                    :text="$t('footer.partner')"
                    :href="config.partnerUrl"
                    target="_blank"
                    v-if="showPartnerLink"
                />
            </div>
            <div class="footer footer-mod-2">
                <p class="footer-links-primary">
                    <template v-if="!FEATURE('footer.store')">
                        <a :href="`${config.officialStore}/${country}`" target="_blank">{{ $t("footer.reolinkStore") }}</a><span>|</span>
                        <a :href="config.support_team" target="_blank">{{ $t("footer.support") }}</a><span>|</span>
                    </template>
                    <a :href="getOfficialUrl( config.about_us )" target="_blank">{{ $t("footer.aboutUs") }}</a><span>|</span>
                    <a :href="getOfficialUrl( config.privacy )" target="_blank">{{ $t("footer.policy") }}</a><span>|</span>
                    <a :href="getOfficialUrl( config.conditions )" target="_blank">{{ $t("footer.term") }}</a><span>|</span>
                    <a href="/terms-of-use/" target="_blank">{{ $t("subscribe.serverRulesName") }}</a>
                </p>
                <p v-if="footerCookieLinkVisibility.showCookiePolicy" class="footer-links-secondary">
                    <a :href="cookiePolicyUrl" target="_blank">{{ $t("footer.cookiePolicy") }}</a>
                    <template v-if="footerCookieLinkVisibility.showDoNotSellOrShare">
                        <span>|</span>
                        <a href="javascript:;" @click.prevent="handleShowCookiePopup">{{ $t("footer.doNotSellOrShare") }}</a>
                    </template>
                </p>
                <div class="payment-wrap" >
                    <ul class="payment" id="apps">
                        <li>
                            <a :href="config.app_store.replace('us', country)" target="_blank">
                                <img :src="getImage('appStore')">
                            </a>
                        </li>
                        <li>
                            <a :href="config.google_play" target="_blank">
                                <img :src="getImage('googlePlay')">
                            </a>
                        </li>
                        <li>
                            <router-link :to="{path:'/user/dashboard/'}">
                                <img :src="getImage('cloudWeb')">
                            </router-link>
                        </li>
                    </ul>
                </div>
                <p class="desc">{{ $t("footer.copyright",{year: copyRightYear}) }}</p>
            </div>
        </div>
    </footer>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import footerImages from '@/common/images/reolink/footer';
import { mapGetters } from 'vuex';
import ReoLink from '@/basic/Link.vue';
import { getPartnerInfo } from '@/api/sim';
import { getCountryWithoutOther } from '@/utils/business';
import gdprCookies from '@reolink-web/gdpr-cookies';
import { ensureGdprCookies, getFooterCookieLinkVisibility } from '@/common/js/gdprCookie';

export default Vue.extend({
    components: {
        ReoLink
    },

    data () {

        return {

            config,
            footerImages,
            showPartnerLink: true

        };

    },

    methods: {

        getImage ( type ) {

            switch ( type ) {

                case 'appStore':
                    return footerImages.appStorePcEN;
                case 'cloudWeb':
                    return footerImages.cloudWebEn;
                case 'googlePlay':
                    return footerImages.googlePlayPcEN;

            }

        },
        async handleShowCookiePopup (): Promise<void> {

            await ensureGdprCookies();
            gdprCookies.show( true );

        }

    },
    computed: {

        ...mapGetters( [

            'isMobile',
            'country',
            'userStatus',
            'isLogin'

        ] as const ),
        footerCookieLinkVisibility(): { showCookiePolicy: boolean; showDoNotSellOrShare: boolean; } {

            return getFooterCookieLinkVisibility();

        },
        copyRightYear () {

            return new Date().getFullYear();

        },
        cookiePolicyUrl (): string {

            return 'https://reolink.com/cookie-policy/?site=cloud&from=footer';

        },

        hasHandle() {

            if (
                this.$route.path.includes( 'subscribe' )
                || this.$route.path.includes( 'checkout' )
            ) {

                return true;

            }
            return false;

        },
        isUserInfoChecked(): boolean {

            return this.userStatus !== '';

        }
    },
    watch: {
        async isUserInfoChecked( newVal ) {

            if ( newVal && this.isLogin ) {

                const partnerInfo = await getPartnerInfo({
                    country: getCountryWithoutOther( this.country )
                });
                this.showPartnerLink = partnerInfo.modules.length === 0;

            }

        }
    }
});
</script>
<style type="text/css" lang="less" scoped>

    .pc-body{

        background-color: #2B2B2B;
        padding: 80px 0;

        .footer-container {
            max-width: 1200px;
            margin: 0 auto;

            .footer{
                margin: 0 auto;
                color: #fff;

                &.footer-mod-1 {
                    padding-bottom: 28px;
                    border-bottom: 1px solid @line_dark;
                    margin-bottom: 40px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .logo-wrap {
                        .pc-logo {
                            width: 151px;
                            height: 27px;
                        }
                        .show-m {
                            display: none !important;
                            &.m-logo {
                                margin: 0 auto;
                                height: 27px;
                                margin-bottom: 24px;
                            }
                        }
                    }
                    /deep/ .ui-link{
                        .text, .ui-icon{
                            color: @white;
                            font-size: 12px;
                        }
                    }
                }

                &.footer-mod-2{
                    color: @white;
                    text-align: center;
                    font-weight: 400;
                    a{
                        color: @white;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 20px;
                        &:hover{
                            color: @white;
                        }
                    }
                    a + span{
                        padding: 0 24px;
                    }
                    .footer-links-secondary {
                        margin-top: 8px;
                    }
                    .desc{
                        font-size: 12px;
                        margin-top: 24px;
                        font-weight: 500;
                        line-height: 20px;
                    }
                    .payment {
                        display: flex;
                        gap: 16px;
                        justify-content: center;
                        margin-top: 24px;
                        li {
                            img {
                                height: 42px;
                                width: auto;
                            }
                        }
                    }
                }

            }
        }

    }

    @media @mobile {

        .pc-body{
            padding: 30px 20px 80px;
            body.has-cart-total &{
                padding-bottom: 148px;
            }
            &.has-handle{
                padding-bottom: 200px;
            }
            .footer-container{
                .footer{
                    &.footer-mod-1 {
                        flex-direction: column;
                        padding-bottom: 0;
                        text-align: center;
                        margin-bottom: 24px;
                        border-bottom: 0;
                        padding-bottom: 24px;
                        border-bottom: 1px solid @line_dark;
                        .logo-wrap {
                            .show-pc {
                                display: none !important;
                            }
                            .show-m {
                                display: block !important;
                            }
                        }
                    }
                    &.footer-mod-2 {
                        text-align: center;

                        a {
                            font-size: 10px;
                        }

                        a + span {
                            font-size: 10px;
                            padding: 0 12px;
                        }

                        .footer-links-secondary {
                            margin-top: 6px;
                        }

                        .desc {
                            margin-top: 24px;
                            font-size: 10px;
                        }
                        .payment-wrap {
                            .payment {
                                gap: 8px;
                            }
                            li {
                                a {
                                    img{
                                        height: 34px;
                                    }
                                }
                            }

                        }
                    }
                }
            }

        }
    }

</style>
